import React from 'react';
import PropTypes from 'prop-types';
import RegistryCollectionHeader from './RegistryCollectionHeader';
import RegistryCollectionItemTile from './RegistryCollectionItemTile';

const RegistryGrid = ({ collection, collectionItems, onAddToCart, onShowProduct, enableCustomCollections, optimizelyTeaseRegistryView, showFullGrid, handleToggleGridReveal }) => {
  if (collectionItems.length === 0) return null;

  // decorate collectionItems here with the css class they need for show/reveal feature
  const collectionItemsDecorated = collectionItems.map((item, idx) => {
    const newItem = Object.assign({}, item);
    let tileCssClass = 'hidden';
    // in first 3 rows on 2-col layout; never show gradient overlay, always show tile
    if (idx < 6) { tileCssClass = 'visible'; }
    // in forth row 2-col layout, show overlay on xs, show tile
    if (idx >= 6 && idx < 8 && collectionItems.length <= 8) { tileCssClass = 'visible'; }
    if (idx >= 6 && idx < 8 && collectionItems.length > 8) { tileCssClass = 'visible obscure-xs'; }
    // conceal tile on xs, show on all other screens
    if (idx === 8) { tileCssClass = 'hidden-xs visible-sm visible-md visible-lg visible-xl'; }
    // conceal tile on xs, show overlay on md, show full tile on lg
    if (idx > 8 && idx < 12) { tileCssClass = 'hidden-xs visible-sm visible-md visible-lg visible-xl obscure-md'; }
    // conceal on xs thru md, show with overlay on lg
    if (idx >= 12 && idx < 16) { tileCssClass = 'hidden-xs hidden-sm hidden-md visible-lg visible-xl obscure-lg'; }
    // hide everything after the 16th one
    if (idx >= 16) { tileCssClass = 'hidden'; }

    newItem.tileCssClass = newItem.tileCssClass ? `${newItem.tileCssClass} ${tileCssClass}` : tileCssClass;
    return newItem;
  });

  return (
    optimizelyTeaseRegistryView ? (
      <div className="registry-grid-expandable">
        <div className={`${showFullGrid ? 'row collection-middle normal' : 'row collection-middle offer-more'}`}>
          {collection && <RegistryCollectionHeader collection={collection} enableCustomCollections={enableCustomCollections} count={collectionItems.length} />}
          <div className={`${collectionItems.length <= 8 ? 'hidden' : 'overlay clearfix visible-xs'} ${collectionItems.length === 9 ? 'visible-sm hidden-md' : ''} ${collectionItems.length > 9 && collectionItems.length <= 12 ? 'visible-sm visible-md' : ''} ${collectionItems.length > 12 ? 'visible-xs visible-sm visible-md visible-lg visible-xl' : 'hidden-lg hidden-xl'}`}>
            <button type="button" className={`btn btn-primary btn-round btn-medium cta ${collection ? 'adjust-for-header' : ''}`} onClick={handleToggleGridReveal}>View Full Registry</button>
          </div>
          {collectionItemsDecorated.map(collectionItem => (
            <div key={collectionItem.object_id} id={collectionItem.object_id} className={`${window.optimizelyShowLargeGrid ? 'col-sm-4 col-xs-6 tile-container' : `col-lg-3 col-sm-4 col-xs-6 tile-container ${!showFullGrid ? collectionItem.tileCssClass : ''}`}`}>
              <RegistryCollectionItemTile
                collectionItem={collectionItem}
                onAddToCart={onAddToCart}
                onShowProduct={onShowProduct}
              />
            </div>
        ))}
        </div>
      </div>
    ) : (
      <div className="row">
        {collection && <RegistryCollectionHeader collection={collection} enableCustomCollections={enableCustomCollections} count={collectionItems.length} />}
        {collectionItems.map(collectionItem => (
          <div key={collectionItem.object_id} id={collectionItem.object_id} className={`${window.optimizelyShowLargeGrid ? 'col-sm-4 col-xs-6' : 'col-lg-3 col-sm-4 col-xs-6'}`}>
            <RegistryCollectionItemTile
              collectionItem={collectionItem}
              onAddToCart={onAddToCart}
              onShowProduct={onShowProduct}
            />
          </div>
        ))}
      </div>
    )
  );
};

RegistryGrid.propTypes = {
  collection: PropTypes.shape({}),
  collectionItems: PropTypes.arrayOf(PropTypes.shape({})),
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired,
  enableCustomCollections: PropTypes.bool,
  optimizelyTeaseRegistryView: PropTypes.bool,
  showFullGrid: PropTypes.bool,
  handleToggleGridReveal: PropTypes.func.isRequired
};

export default RegistryGrid;



// WEBPACK FOOTER //
// ./src/components/registry/RegistryGrid.jsx